import BottomDrawer from ".";
import { withTabContnet } from "../tab/withTabContent";
import ReportDrawerLayout from "../../layout/community/ReportDrawerLayout";
import * as React from "react";
import Tabs, { useTabs } from "../tab";
import MoreDrawerLayout from "../../layout/community/MoreDrawerLayout";

interface MoreDrawerProps {
  open: boolean;
  onClose: () => void;
  onClick?: (value: string) => void;
  isMyItem?: boolean;
  type: "ARTICLE" | "COMMENT";
  articleId: string | number;
  commentId: string | number;
  storeCode: string;
}

export default function MoreDrawer({
  open,
  onClose,
  isMyItem = false,
  type,
  onClick,
  articleId,
  commentId,
  storeCode,
}: MoreDrawerProps) {
  const { currentTab, next } = useTabs(1);

  const MoreScreenTab = React.useMemo(
    () => withTabContnet(MoreDrawerLayout, {}),
    [],
  );
  const ReportScreenTab = React.useMemo(
    () => withTabContnet(ReportDrawerLayout, {}),
    [],
  );

  return (
    <BottomDrawer open={open} onClose={onClose}>
      <section>
        <p className="text-xl font-bold">
          {currentTab === 1 ? "더보기" : "신고하기"}
        </p>
        <div className="mt-[25px]">
          <Tabs currentTab={currentTab}>
            <MoreScreenTab
              onClose={onClose}
              isMyItem={isMyItem}
              type={type}
              articleId={articleId}
              onClick={onClick}
              storeCode={storeCode}
              commentId={commentId}
              next={next}
            />
            <ReportScreenTab
              type={type}
              relatedId={type === "ARTICLE" ? articleId : commentId}
              onClose={onClose}
            />
          </Tabs>
        </div>
      </section>
    </BottomDrawer>
  );
}
